<template lang="pug">
  v-col(cols="9" class="py-0 pr-8 d-flex flex-column justify-space-between")
    div
      v-row(no-gutters justify="space-between")
        span(class="text-title") {{ titleText }}
        span(class="text-price") {{ priceText }}
      v-row(no-gutters justify="space-between" align="start")
        span(class="text-floor") {{ floorText }}
        span(class="text-duration") {{ duration }}
    div
      v-row(no-gutters justify="start")
        v-col(cols="12")
          div(class="text-description") {{ advertItem.description }}
    div
      v-row(no-gutters justify="space-between" align="center")
        div
          v-icon(color="#B9B9B9" class="mr-2") account_circle
          span Частное лицо
        div
          v-icon(class="mr-2" color="#B9B9B9") visibility
          span(class="text-views mr-4") {{ advertItem.countViews }}
          span(class="text-views") {{ dateText }}
</template>

<script>
export default {
  name: 'ItemDescription',
  props: {
    advertItem: {
      type: Object,
      default: () => ({})
    },
    titleText: {
      type: String,
      default: ''
    },
    priceText: {
      type: String,
      default: ''
    },
    floorText: {
      type: String,
      default: ''
    },
    dateText: {
      type: String,
      default: ''
    },
    duration: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.text {
  &-floor {
    font-size: 11px;
    line-height: 15px;
    letter-spacing: -0.812778px;
    color: #8e8e93;
  }
  &-title {
    font-weight: 700;
    font-size: 16px;
    color: #000000;
  }
  &-price {
    font-weight: 700;
    font-size: 16px;
    color: #0091ff;
  }
  &-description {
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.812778px;
    color: #333333;
    max-height: 48px;
    height: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  &-views {
    font-size: 12px;
    line-height: 16px;
    color: #7c7c7c;
  }
  &-duration {
    font-weight: bold;
    font-size: 12px;
    text-align: right;
    color: #0091ff;
    line-height: 15px;
  }
}
</style>
